/**
 * 导航头-产品hover弹窗
 */

import React, { Component, useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, Icon } from 'antd';
import './index.less';
import EnterpriseWeChat from "../EnterpriseWeChat";

const NewPopAi = (props) => {
  const { style = {}, title = "", data = [], extraText = "", extraUrl = "" } = props;

  const [tabIndex, setTabIndex] = useState(0);
  const [colSpan, setColSpan] = useState(Math.floor(24 / ((data[0] && data[0].data && data[0].data.length) || 1)));
  const [maxContentHight, setMaxContentHight] = useState(356); //最大高度

  useEffect(() => {
    watchWindowSize()
    window.addEventListener('resize', watchWindowSize);
    return () => {
      window.removeEventListener('resize', watchWindowSize);
    }
  }, [])

  const watchWindowSize = useCallback(() => {
    let h = document.documentElement.clientHeight * 0.8;
    setMaxContentHight(h > 300 ? h : 300);
  }, [])


  // tabs点击事件
  const onTabsClick = useCallback((item, index) => {
    if (item.href && item.href != '') {
      window.location.href = item.href
    } else {
      setTabIndex(index);
      setColSpan(Math.floor(24 / ((data[index] && data[index].data && data[index].data.length) || 1)))
    }

  }, [])

  // tabs鼠标悬浮事件
  const onTabsMouseEnter = useCallback((item, index) => {
    setTabIndex(index);
    setColSpan(Math.floor(24 / ((data[index] && data[index].data && data[index].data.length) || 1)))
  }, [])

  // 埋点
  const onMonitor = useCallback((item) => {
    window.monitor && window.monitor.report({ textKey: 'website_newpopsolution_left', text: item.title || '' });
  }, [])

  return (
    <div style={style} className="NewPopAi">
      <div className='NewPop-tabs' style={{ maxHeight: (maxContentHight - 30) + 'px' }}>
        {data.map((item, index) => {
          const hrefTag = item.href && item.href != '';

          return <div className="NewPop-tabs-items-ai" onMouseEnter={() => { onTabsMouseEnter(item, index) }}>
            <div className="NewPop-tabs-items-title" style={item.titleStyle}>{item.title}</div>
            <div className="NewPop-tabs-items-subtitle" style={item.subTitleStyle}>{item.subTitle}</div>
            {item.extra && <a className="NewPop-tabs-items-extra" style={item.extra.style}
              target={item.extra.target || "_blank"} href={item.extra.href} onClick={() => onMonitor(item)}>
              {item.extra.title}
              <img src="https://resource.eziot.com/group2/M00/00/C3/CtwQFmVayeqAVNblAAAB0wTH9LQ159.png" />
            </a>}
          </div>
        })}
      </div>

      <div style={{ maxHeight: (maxContentHight - 30) + 'px' }} className="NewPop-content-border">
        <Row gutter={20} className="NewPop-content-row">
          <div className='NewPop-content' style={{ maxHeight: (maxContentHight - 32) + 'px' }}>
            <Row align="stretch" gutter={20} style={{ width: '100%' }}>
              {data && data[tabIndex] && data[tabIndex].data && data[tabIndex].data.length > 0 && data[tabIndex].data.map((item, tIndex) =>
                <ColItem key={'NewPop-content-' + tIndex} data={item} colSpan={colSpan} />)
              }
            </Row>
          </div>
        </Row>
      </div>

    </div>
  )
}

// 第一级标题+内容
const ColItem = ({ data, colSpan }) => {
  return <Col span={colSpan}>
    {data && data.length > 0 && data.map((item, index) => 
      <div key={'NewPop-content-' + index} style={item.style} className='NewPop-content-item'>
        <div className='sub-item'>
          { item.title && <div style={item.titleStyle} className='content-item-title'>{item.title}</div> }
          <div className='sub-item-content'>
            { item && item.secondaryData && item.secondaryData.length > 0 && item.secondaryData.map((item, subIndex) => 
              <SecondaryItem key={subIndex} data={item} />
            )}
          </div>

        </div>
      </div>)}
  </Col>
}

// 第二级标题+内容
const SecondaryItem = ({ data }) => {
  return <div style={data.style} className='sub-item-content-rank'>
    { data.title && <div style={data.titleStyle} className='content-secondary-item'>{data.title}</div> }
    { data && data.thirdData && data.thirdData.length > 0 && data.thirdData.map((item, index) => 
      <ThirdItem key={index} index={index} data={item} />
    )}
  </div>
}

// 第三级，链接
const ThirdItem = ({ data }) => {

  const target = useRef(data.href.startsWith('http') || data.target == '_blank' ? (data.target || "_self") : undefined)

  const onClick = useCallback((title="") => {
    window.monitor && window.monitor.report({ textKey: 'website_newpopsolution_item_type', text: title || '' });
  }, [])

  return data.isWeChat ? 
    <EnterpriseWeChat
      title={data.weChatTitle || ""}
      weChatImg={data.weChatImg || ""}
      weChatDesc={data.weChatDesc || ""}
      modalZIndex={9999}  // 防止被导航栏弹窗遮挡
    >
      <div className='content-sublist-item'  onClick={() => onClick(data.title)} style={data.titleStyle}>{data.title}</div>
    </EnterpriseWeChat> : 
    <a target={target.current} href={data.href} onClick={() => onClick(data.title)}>
      <div className='content-sublist-item' style={data.titleStyle}>{data.title}</div>
    </a>
}


export default NewPopAi;
